import { useState } from "react";
import { toast } from "sonner";
import { Upload, Download } from "lucide-react";
import { api, formatErr } from "../lib/api";
import { todayISO } from "../lib/format";
import { BTN } from "./Common";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

const downloadTemplate = () => {
  const d = todayISO();
  const csv = `employee_code,date,check_in,check_out,status\nMBV-101,${d},09:30,18:30,\nMBV-102,${d},,,absent\n`;
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "attendance_template.csv";
  a.click();
  URL.revokeObjectURL(url);
};

export const AttendanceUpload = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const upload = async () => {
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/attendance/upload", fd);
      setRes(data);
      toast.success(`${data.imported} attendance rows imported`);
      onDone?.();
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };

  return (
    <>
      <Button onClick={() => { setOpen(true); setRes(null); setFile(null); }} className={BTN} data-testid="upload-attendance-button"><Upload className="h-4 w-4 mr-1" />Upload attendance</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-white" data-testid="upload-attendance-dialog">
          <DialogHeader><DialogTitle>Upload attendance</DialogTitle></DialogHeader>
          <div className="space-y-4 text-sm">
            <p className="text-[#6E6E73]">Upload a CSV or Excel file with columns <b>employee_code, date (YYYY-MM-DD), check_in, check_out (HH:MM, IST), status</b>. Status is optional: present, late, absent or half_day. Existing records for the same employee and date are replaced.</p>
            <Button variant="outline" size="sm" onClick={downloadTemplate} data-testid="download-template-button"><Download className="h-4 w-4 mr-1" />Download template</Button>
            <Input type="file" accept=".csv,.xlsx,.xls" onChange={(e) => setFile(e.target.files[0] || null)} data-testid="attendance-file-input" />
            <Button disabled={!file || busy} onClick={upload} className={`w-full ${BTN}`} data-testid="attendance-upload-submit">{busy ? "Uploading..." : "Upload"}</Button>
            {res && (
              <div className="rounded-xl bg-[#F5F5F7] p-3" data-testid="upload-result">
                <div className="font-semibold">{res.imported} imported · {res.error_count} skipped</div>
                {res.errors.map((e) => <div key={e.row} className="text-xs text-red-600 mt-1">Row {e.row}: {e.error}</div>)}
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
